import React, { useState, useEffect } from 'react';
import { isMobileDevice } from '../../../common/utilities/utils';
import CartHeaderItem from './ReusableComponents/CartHeaderItem';
import CartSummaryCard from './ReusableComponents/CartSummaryCard';
import FoodItemList from './ReusableComponents/FoodItemList';
import IndulgentAddOn from './ReusableComponents/IndulgentAddOn';
import FaqComponent from './ReusableComponents/FaqComponent';
import CartNotification from './ReusableComponents/CartNotification';

const CartPageItems = props => {
  const {
    contentData = {},
    currencySymbol = '',
    currencyConversionFactor = '',
    addHope = '',
    carryBag = '',
    isModalOpen,
    confirmChangesHandler,
    tenantId = '',
    maxItemCountPerLineItem,
    faqAndContactData = {},
    dispositionData = {},
    showPriceWithTax = false,
  } = props;
  const { cartList = [], cartSummary = {}, bucketId = '' } = contentData;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const desktopCart = () => {
    return (
      <div className='cart-page-container-desktop grid-container' data-testid='cart-page-desktop-test'>
        <div className='cart-header-container-desktop' isMobile={false}>
          <CartHeaderItem />
        </div>
        <div className='cart-content-container-desktop'>
          <div className='cart-content-foodItemList'>
            <FoodItemList
              contentData={cartList}
              isMobile={false}
              currencySymbol={currencySymbol}
              addHope={addHope}
              carryBag={carryBag}
              maxItemCountPerLineItem={maxItemCountPerLineItem}
              cartSummary={cartSummary}
              bucketId={bucketId}
              showPriceWithTax={showPriceWithTax}
            />
          </div>
          <CartSummaryCard
            contentData={cartSummary}
            currencySymbol={currencySymbol}
            currencyConversionFactor={currencyConversionFactor}
            addHope={addHope}
            carryBag={carryBag}
            isMobile={false}
            confirmChangesHandler={confirmChangesHandler}
            tenantId={tenantId}
            bucketId={bucketId}
            dispositionData={dispositionData}
          />
        </div>
        {cartSummary.recommendedItems.length > 0 && (
          <div className='cart-addon-container-desktop'>
            <IndulgentAddOn isMobile={false} IndulgentData={cartSummary.recommendedItems} />
          </div>
        )}
        <div className='cart-faq-container-desktop'>
          <FaqComponent faqAndContactData={faqAndContactData} isMobile={false} history={props.history} />
        </div>
      </div>
    );
  };

  const mobileCart = () => {
    return (
      <div className='cart-page-container-mobile' data-testid='cart-page-mobile-test'>
        <div className='cart-header-container-mobile' isMobile={true}>
          <CartHeaderItem />
        </div>
        <div className='cart-notification'>
          <CartNotification contentData={cartList} isModalOpen={isModalOpen} />
        </div>
        <div className='cart-content-container-mobile'>
          <FoodItemList
            contentData={cartList}
            isMobile={true}
            currencySymbol={currencySymbol}
            addHope={addHope}
            carryBag={carryBag}
            maxItemCountPerLineItem={maxItemCountPerLineItem}
            cartSummary={cartSummary}
            bucketId={bucketId}
          />
        </div>
        {cartSummary.recommendedItems.length > 0 && (
          <div className='cart-addon-container-mobile'>
            <IndulgentAddOn isMobile={true} IndulgentData={cartSummary.recommendedItems} />
          </div>
        )}
        <div className='cart-summary-card-mobile'>
          <CartSummaryCard
            contentData={cartSummary}
            currencySymbol={currencySymbol}
            currencyConversionFactor={currencyConversionFactor}
            addHope={addHope}
            carryBag={carryBag}
            isMobile={true}
            confirmChangesHandler={confirmChangesHandler}
            tenantId={tenantId}
            bucketId={bucketId}
            dispositionData={dispositionData}
          />
        </div>
        <div className='cart-faq-container-mobile'>
          <FaqComponent faqAndContactData={faqAndContactData} isMobile={true} history={props.history} />
        </div>
      </div>
    );
  };
  return isMobile ? mobileCart() : desktopCart();
};

export default CartPageItems;
